export default "__VITE_ASSET__Bj0aFok7__"